import React, { useEffect, useState, useRef } from 'react'
import './SimFormSections.scss'
import moment from 'moment'
import SignaturePad from 'react-signature-canvas'
import { useIndexedDB } from 'react-indexed-db';
import Text from "../../../formitems/Text.js";
import { Formik, Form, Field, FieldArray } from 'formik';
import firebase from 'firebase'
import Loading from './../../../../assets/images/loading.gif'
import blankImage from './../../../../assets/images/blankimage.jpg'
import { submitsimform, SaveUrlSimForm, graphsimform, submitstcform, checkSimFormPublished, simformpreview, deleteformpreview } from '../SimulatorQuery/SimulatorFormQuery'
import apollo_client from '../../../../apollo_client';
import { useAlert } from "react-alert";
import "../../../../assets/styles/custom/components/dashboard/Crew.scss";
import { Select } from 'antd';

function SimFormSections({ simformdata, startdate, enddate, index, setedit }) {

    const alert = useAlert();
    const { getAll: GetAllSfrid, update: updatesfrid, deleteRecord: deletesfrid, getByIndex } = useIndexedDB('sfrid');
    const { getAll: GetAllSTC, update: updatestcid } = useIndexedDB('stcid');
    const [active, setactive] = useState("header");
    const [totalscore, settotalscore] = useState(simformdata.cal)
    const [loading, setloading] = useState(false)
    const [satifactory, setSatifactory] = useState('')
    const [showSubmit, setshowSubmit] = useState(false)
    const [simformdetails, SetSimformdetails] = useState(simformdata)
    const signaturPadRef = useRef({})
    let signatureSave = ""
    // async function checkAlreadyPublished() {
    //     let sim = await apollo_client.query({
    //         query: checkSimFormPublished,
    //         variables: {
    //             sfrid: simformdetails.sfrid
    //         }
    //     });
    //     console.log(sim.data.aatmsv4_simformrecords)
    //     let data = sim.data.aatmsv4_simformrecords;
    //     if (data.length > 0) {
    //         getByIndex('sfrid', simformdetails.sfrid).then(sfirdFromDB => {
    //             if (sfirdFromDB) {
    //                 deletesfrid(sfirdFromDB.id).then(event => {
    //                     setedit(false)
    //                     setloading(false)
    //                     alert("Form has been already submitted")
    //                 });
    //             }
    //         });
    //         return await true;
    //     } else {
    //         return await false
    //     }
    // }
    async function submitformIndex() {
        let data = { ...simformdetails };
        data.published = true;
        data.preview = false;
        data.timestamp = new Date().toISOString();
        data.stcrecords.forEach(stcrecords => {
            stcrecords.published = true;
        });
        SetSimformdetails(data);
        console.log("Submit button click", data)
        updatesfrid(data).then(event => {
            alert.show("Submitted Successfully ");
            setedit(false);
        }).catch(error => {
            console.log(error)
        })
    }
    // async function submitform(publishform) {
    //     if (!navigator.onLine) {
    //         alert("Progress may be lost because there is no internet connection !!!’")
    //         return;
    //     }
    //     setloading(true)
    //     let checkpublished = await checkAlreadyPublished();
    //     if (checkpublished) {
    //         return;
    //     }
    //     console.log("after Submit")
    //     console.log(simformdetails)

    //     apollo_client.mutate({
    //         mutation: submitsimform,
    //         variables: {
    //             sfrid: simformdetails.sfrid,
    //             published: publishform,
    //             preview: !publishform,
    //             knowledge: simformdetails.knowledge,
    //             skil: simformdetails.skil,
    //             attitude: simformdetails.attitude,
    //             app: simformdetails.app,
    //             tkn: simformdetails.tkn,
    //             fpa: simformdetails.fpa,
    //             fpm: simformdetails.fpm,
    //             com: simformdetails.com,
    //             ltw: simformdetails.ltw,
    //             pdm: simformdetails.pdm,
    //             saw: simformdetails.saw,
    //             wlm: simformdetails.wlm,
    //             cal: simformdetails.cal,
    //             remarkstext: simformdetails.remarkstext,
    //             resulttext: simformdetails.resulttext,
    //             traineesign: simformdetails.traineesign,
    //             trainersign: simformdetails.trainersign
    //         }
    //     }).then(simformdata => {
    //         let stclength = simformdetails.stcrecords.length;
    //         let i = 0;
    //         if (stclength) {
    //             simformdetails.stcrecords.forEach(stcrecords => {
    //                 apollo_client.mutate({
    //                     mutation: submitstcform,
    //                     variables: {
    //                         ata: 1,
    //                         sits: stcrecords.sits,
    //                         score: stcrecords.score,
    //                         patch: stcrecords.patch,
    //                         published: publishform,
    //                         sfrid: stcrecords.sfrid,
    //                         stcrid: stcrecords.stcrid
    //                     }
    //                 }).then(data => {
    //                     i = i + 1;
    //                     if (stclength === i) {
    //                         previewaftersave(publishform)
    //                     }
    //                 }).catch(error => {
    //                     console.log(error)
    //                 })

    //             })
    //         } else {
    //             previewaftersave(publishform)
    //             alert("Submitted Successfully ");
    //         }
    //     }).catch(error => {
    //         console.log(error)
    //     })

    // }
    function deleteform() {
        setloading(true);
        if (navigator.onLine) {
            apollo_client.mutate({
                mutation: deleteformpreview,
                variables: {
                    sfrid: simformdetails.sfrid
                }
            }).then(data => {
                setloading(false);
                getByIndex('sfrid', simformdetails.sfrid).then(sfirdFromDB => {
                    if (sfirdFromDB) {
                        deletesfrid(sfirdFromDB.id).then(event => {
                            setedit(false)
                        });
                    }
                });
                alert.show("Deleted Successfully")
            })
        }
        else {
            setloading(false);
            alert.show("Requires Internet Connection for deletion")
        }
    }
    // function previewaftersave(publishform) {
    //     apollo_client.query({
    //         query: simformpreview,
    //         variables: {
    //             sfrid: simformdetails.sfrid,
    //             preview: !publishform,
    //             published: publishform
    //         }
    //     }).then(querypreview => {
    //         let simformpreview = querypreview.data.aatmsv4_simformrecords[0];
    //         let generateSimForm = firebase.functions().httpsCallable('sim-training-form');
    //         let requestobj = {
    //             aatmsv4_simforms: [simformpreview],
    //             stcrecords: simformpreview.stcrecords
    //         }
    //         if (publishform) {
    //             let isgraph = false;
    //             simformdetails.stcrecords.forEach(stcrecords => {
    //                 if (stcrecords.patch !== '') {
    //                     isgraph = true
    //                 }
    //             });
    //             if (isgraph) {
    //                 let start = moment(startdate).format('YYYY-MM-DD');
    //                 let end = moment(enddate).format('YYYY-MM-DD');
    //                 apollo_client.query({
    //                     query: graphsimform,
    //                     variables: {
    //                         crewid: simformdetails.traineeid,
    //                         start: start,
    //                         end: end
    //                     }
    //                 }).then(graphdata => {
    //                     const generateGraphSimForm = firebase.functions().httpsCallable('trainingPerformanceReport');
    //                     let graphobj = {
    //                         aatmsv4_crews: [graphdata.data.aatmsv4_crews[0]]
    //                     }
    //                     console.log(JSON.stringify(graphobj));
    //                     generateGraphSimForm(graphobj)
    //                         .then((simgraph) => {
    //                             console.log("graph generated")
    //                             console.log(simgraph)
    //                         }).catch(error => {
    //                             console.log(error)
    //                         })
    //                 });
    //             }
    //             getByIndex('sfrid', simformdetails.sfrid).then(sfirdFromDB => {
    //                 if (sfirdFromDB) {
    //                     deletesfrid(sfirdFromDB.id).then(event => {
    //                     });
    //                 }
    //             });
    //         }
    //         console.log(JSON.stringify(requestobj));
    //         generateSimForm(requestobj)
    //             .then((simformdata) => {
    //                 console.log(simformdata);

    //                 apollo_client.mutate({
    //                     mutation: SaveUrlSimForm,
    //                     variables: {
    //                         sfrid: simformdetails.sfrid,
    //                         stcrecord: simformdata.data.url
    //                     }
    //                 }).then(data => {
    //                     setloading(false)
    //                     alert("Submitted Successfully ");
    //                     const newWindow = window.open(simformdata.data.url, '_blank', 'noopener,noreferrer')
    //                     if (newWindow) newWindow.opener = null
    //                     if (publishform) {
    //                         setedit(false)
    //                     }
    //                 })
    //             })
    //             .catch(err => {
    //                 console.log(`Error Occured!! ${err}`);
    //             });
    //     })
    // }
    useEffect(() => {

        let start = moment(startdate).format('YYYY-MM-DD');
        let end = moment(enddate).format('YYYY-MM-DD');
        let resultdata = [];
        setloading(false);
        GetAllSfrid().then(sfriddata => {
            sfriddata.forEach(sfridresponse => {
                if (sfridresponse.date >= start && sfridresponse.date <= end) {
                    let data = { ...sfridresponse };
                    resultdata.push(data)
                }
            })
            SetSimformdetails(resultdata[index]);
        });
    }, [])
    const show = () => {
        if (simformdetails.traineesign && simformdetails.traineesign !== null && signaturPadRef && signaturPadRef !== null) {
            signaturPadRef.current.fromDataURL(simformdetails.traineesign)
        }
    }
    useEffect(() => {

        SetSimformdetails(simformdata)
        show();
    }, [simformdata])
    if (loading) {

        return (< img style={{ padding: 100 }} src={loading ? Loading : null}
            height="50%"
            alt=""
            width="50%"
        />)
    }
    return (
        <Formik
            initialValues={simformdetails}
            enableReinitialize
            validate={(values) => {

                let total = (Number(values.app) * Number(values.app))
                    + (Number(values.tkn) * Number(values.tkn))
                    + (Number(values.fpa) * Number(values.fpa))
                    + (Number(values.fpm) * Number(values.fpm))
                    + (Number(values.com) * Number(values.com))
                    + (Number(values.ltw) * Number(values.ltw))
                    + (Number(values.pdm) * Number(values.pdm))
                    + (Number(values.saw) * Number(values.saw))
                    + (Number(values.wlm) * Number(values.wlm));
                settotalscore(total)

                if (values.traineesign && values.traineesign !== '' &&
                    values.knowledge && values.knowledge !== '' &&
                    values.skil && values.skil !== '' &&
                    values.attitude && values.attitude !== '' &&
                    values.remarkstext && values.remarkstext !== '' &&
                    values.resulttext && values.resulttext !== ''
                ) {
                    values.cal = totalscore;

                    values.timestamp = new Date().toISOString();
                    SetSimformdetails(prev => {
                        return { ...values }
                    })
                    console.log(values)
                    updatesfrid(values).then(event => {
                        values.stcrecords.forEach(stcrecords => {
                            updatestcid(stcrecords).then(event => {
                            }).catch(error => {
                                console.log(error)
                            })
                        })
                    }).catch(error => {
                        console.log(error)
                    })
                    setshowSubmit(true)
                } else {
                    setshowSubmit(false)
                }
            }}
            onSubmit={(values, { setSubmitting }) => {
                values.cal = totalscore;
                SetSimformdetails(prev => {
                    return { ...values }
                })
                console.log(values)
                updatesfrid(values).then(event => {
                    values.stcrecords.forEach(stcrecords => {
                        updatestcid(stcrecords).then(event => {
                        }).catch(error => {
                            console.log(error)
                        })
                    })
                }).catch(error => {
                    console.log(error)
                })
                setSubmitting(false)
            }}>
            {({ values, setFieldValue, handleSubmit }) => {
                return (
                    <Form>
                        <header className="simulator-form-header">
                            <div
                                className={active === "header" ? "borderheader-sim" : ""}
                                onClick={(e) => {
                                    setactive("header");
                                    handleSubmit(e);
                                }}
                            >
                                Header
                                 </div>
                            <div
                                className={active === "tech-comp" ? "borderheader-sim" : ""}
                                onClick={(e) => {
                                    setactive("tech-comp");
                                    handleSubmit(e);
                                }}
                            >
                                Technical Competency
                                 </div>
                            <div
                                className={active === "non-tech-comp" ? "borderheader-sim" : ""}
                                onClick={(e) => {
                                    setactive("non-tech-comp");
                                    handleSubmit(e);
                                }}
                            >
                                Non-Technical Competency
                                 </div>
                            <div
                                className={active === "remark" ? "borderheader-sim" : ""}
                                onClick={(e) => {
                                    setactive("remark");
                                    handleSubmit(e);
                                }}
                            >
                                Remark & Result
                                 </div>
                            <div
                                className={active === "signature" ? "borderheader-sim" : ""}
                                onClick={(e) => {
                                    setactive("signature");
                                    handleSubmit(e);
                                }}
                            >
                                Signature
                                </div>
                        </header>

                        <div className={active === "header" ? "" : "hide-element"}>
                            <div className="table-body-container">
                                <div className="table-body-header">All Simulators</div>
                                    <div className="header-form-container">
                                        <div className=" header-form-box header-form-box--1">
                                            <div className="">
                                                <span>Airline</span>
                                            </div>
                                            <input
                                                type="text"
                                                disabled
                                                name="clientname"
                                                value={simformdetails.clientname}
                                                className="header-form-input"
                                            />
                                        </div>
                                        <div className=" header-form-box header-form-box--2">
                                            <div className="">
                                                <span>Date</span>
                                            </div>
                                            <input
                                                name="date"
                                                value={simformdetails.date}
                                                disabled
                                                className="header-form-input"
                                                type="text"
                                            />
                                        </div>
                                        <div className=" header-form-box header-form-box--3">
                                            <div className="">
                                                <span>Fleet</span>
                                            </div>
                                            <input
                                                name="fleet"
                                                value={simformdetails.fleet}
                                                disabled
                                                className="header-form-input"
                                                type="text"
                                            />
                                        </div>
                        
                           
                             
                                        <div className=" header-form-box header-form-box--4">
                                            <div className="">
                                                <span>Sim Location</span>
                                            </div>
                                            <input
                                            name="simlocation"
                                            value={simformdetails.simlocation}
                                            disabled
                                            className="header-form-input"
                                            type="text"
                                            />
                                        </div>    
                                        <div className=" header-form-box header-form-box--5">
                                            <div className="">
                                                <span>Sim Type</span>
                                            </div>
                                            <input
                                                name="simtype"
                                                value={simformdetails.simtype}
                                                disabled
                                                className="header-form-input"
                                                type="text"
                                            />
                                        </div>
                                        <div className=" header-form-box header-form-box--6">
                                            <div className="">
                                                <span>Sim Registration</span>
                                            </div>
                                            <input
                                                name="simreg"
                                                value={simformdetails.simreg}
                                                disabled
                                                className="header-form-input"
                                                type="text"
                                            />
                                        </div>
                            
                              
                                        <div className=" header-form-box header-form-box--7">
                                            <div className="">
                                                <span>Sim Form Name</span>
                                            </div>
                                        <input
                                            name="simformid"
                                            value={simformdetails.simformname}
                                            disabled
                                            className="header-form-input"
                                            type="text"
                                        />
                                        </div>

                                        
                              
                            
                            
                                        <div className=" header-form-box header-form-box--8">
                                            <div className="">
                                                <span>Trainer Name</span>
                                            </div>
                                            <input
                                                name="name"
                                                value={simformdetails.name}
                                                disabled
                                                className="header-form-input"
                                                type="text"
                                            />
                                        </div>
                                        <div className=" header-form-box header-form-box--9">
                                            <div className="">
                                                <span>Rank</span>
                                            </div>
                                            <input
                                                name="rank"
                                                value={simformdetails.rank}
                                                disabled
                                                className="header-form-input"
                                                type="text"
                                            />
                                        </div>
                                        <div className=" header-form-box  header-form-box--10">
                                            <div className="">
                                                <span>Licence</span>
                                            </div>
                                            <input
                                                name="licence"
                                                value={simformdetails.licence}
                                                disabled
                                                className="header-form-input"
                                                type="text"
                                            />
                                        </div>
                                
                                
                                   
                                        <div className=" header-form-box header-form-box--11">
                                                <div className="">
                                                    <span>Trainee Name</span>
                                                </div>
                                            <input
                                                name="traineename"
                                                value={simformdetails.traineename}
                                                disabled
                                                className="header-form-input"
                                                type="text"
                                            >
                                            </input>
                                        </div>   
                                            <div className=" header-form-box header-form-box--12">
                                                <div className="">
                                                    <span>Rank</span>
                                                </div>
                                                <input
                                                    name="traineerank"
                                                    value={simformdetails.traineerank}
                                                    disabled
                                                    className="header-form-input"
                                                    type="text"
                                                />
                                            </div>
                                            <div className=" header-form-box header-form-box--13">
                                                <div className="">
                                                    <span>Licence</span>
                                                </div>
                                                <input
                                                    name="traineelicence"
                                                    value={simformdetails.traineelicence}
                                                    disabled
                                                    className="header-form-input"
                                                    type="text"
                                                />
                                            </div>
                                        </div>    
                                  
                            </div>
                        </div>
                        <div className={active === "tech-comp" ? "" : "hide-element"}>
                            <div className="table-body-container">
                                <div className="table-body-header">
                                    Section 2: Technical Competency
                                     </div>
                                <div className="client-list-divider"></div>
                                <FieldArray name="stcrecords"
                                    render={arrayHelpers => {
                                        return (

                                            <div className={active === "tech-comp" ? "" : "hide-element"}>
                                                {
                                                    values && values.stcrecords.length > 0 ? values.stcrecords.map((stcrecord, index) => (
                                                        <div className="table-container" key={index}>
                                                          
                                                            <div className="technical-form-container" >
                                                                <div className=" technical-form-box1" >
                                                                    <Text title="#" value={index + 1} disabled />
                                                                </div>
                                                                <div className="technical-form-box2">
                                                                    <Text name={`stcrecords[${index}].stcname`} value={stcrecord.stcname} title="Technical Competency" disabled style={{ width: '100px !important' }} />
                                                                </div>
                                                               
                                                                <div className="technical-form-rating technical-form-box3" >
                                                                        <div className="">
                                                                            <p>Resits</p>
                                                                        </div>
                                                                        
                                                                        <div className="rating-1">
                                                                                <input  id={`stcrecords.${index}.sits + "5"`} checked={values.stcrecords[index].sits === 5} onChange={(e) => { setFieldValue(`stcrecords[${index}].sits`, 5) }} className="technical-form-checkbox" type="radio" name={`stcrecords.${index}.sits`} value={5} /><label for={`stcrecords.${index}.sits + "5"`}>
                                                                                </label>
                                                                                <input id={`stcrecords.${index}.sits + "4"`} checked={values.stcrecords[index].sits === 4} onChange={(e) => { setFieldValue(`stcrecords[${index}].sits`, 4) }} className="technical-form-checkbox" type="radio" name={`stcrecords.${index}.sits`} value={4} /><label for={`stcrecords.${index}.sits + "4"`}>
                                                                                </label>
                                                                                <input  id={`stcrecords.${index}.sits + "3"`} checked={values.stcrecords[index].sits === 3} onChange={(e) => { setFieldValue(`stcrecords[${index}].sits`, 3) }} className="technical-form-checkbox" type="radio" name={`stcrecords.${index}.sits`} value={3} /><label for={`stcrecords.${index}.sits + "3"`}>
                                                                                </label>
                                                                                <input  id={`stcrecords.${index}.sits + "2"`} checked={values.stcrecords[index].sits === 2} onChange={(e) => { setFieldValue(`stcrecords[${index}].sits`, 2) }} className="technical-form-checkbox" type="radio" name={`stcrecords.${index}.sits`} value={2} /><label for={`stcrecords.${index}.sits + "2"`}>
                                                                                </label>
                                                                                <input id={`stcrecords.${index}.sits + "1"`} checked={values.stcrecords[index].sits === 1} onChange={(e) => { setFieldValue(`stcrecords[${index}].sits`, 1) }} className="technical-form-checkbox" type="radio" name={`stcrecords.${index}.sits`} value={1} /><label for={`stcrecords.${index}.sits + "1"`}>
                                                                                </label>
                                                                        </div>

                                                                            {/* <Field component="select" value={stcrecord.sits} name={`stcrecords.${index}.sits`}>
                                                                                <option value="1">"1"</option>
                                                                                <option value="2">"2"</option>
                                                                                <option value="3">"3"</option>
                                                                                <option value="4">"4"</option>
                                                                                <option value="5">"5"</option>
                                                                            </Field> */}
                                                                </div>
                                                                <div className="technical-form-rating technical-form-box4">
                                                                        <div className="">
                                                                            <span>Score</span>
                                                                        </div>
                                                                        <div className="rating-2">
                                                                            <input  id={`stcrecords.${index}.sits + "51"`} checked={values.stcrecords[index].score === 5} onChange={(e) => { setFieldValue(`stcrecords[${index}].score`, 5) }}  type="radio"  className="technical-form-checkbox" name={`stcrecords.${index}.score`} value={5} /><label for={`stcrecords.${index}.sits + "51"`}>
                                                                            </label>
                                                                            <input  id={`stcrecords.${index}.sits + "41"`}  checked={values.stcrecords[index].score === 4} onChange={(e) => { setFieldValue(`stcrecords[${index}].score`, 4) }}  type="radio" className="technical-form-checkbox" name={`stcrecords.${index}.score`} value={4} /><label for={`stcrecords.${index}.sits + "41"`}>
                                                                            </label>
                                                                            <input  id={`stcrecords.${index}.sits + "31"`} checked={values.stcrecords[index].score === 3} onChange={(e) => { setFieldValue(`stcrecords[${index}].score`, 3) }}  type="radio" className="technical-form-checkbox" name={`stcrecords.${index}.score`} value={3} /><label for={`stcrecords.${index}.sits + "31"`}>
                                                                            </label>
                                                                            <input   className="technical-form-checkbox" id={`stcrecords.${index}.sits + "21"`} checked={values.stcrecords[index].score === 2} onChange={(e) => {
                                                                                setFieldValue(`stcrecords[${index}].score`, 2);
                                                                                if (values.stcrecords[index].patch === "") {
                                                                                    setFieldValue(`stcrecords[${index}].patch`, "App")
                                                                                }
                                                                            }}  type="radio" name={`stcrecords.${index}.score`} value={2} /><label for={`stcrecords.${index}.sits + "21"`}>
                                                                            </label>
                                                                            <input  className="technical-form-checkbox" id={`stcrecords.${index}.sits + "11"`} checked={values.stcrecords[index].score === 1} onChange={(e) => {
                                                                                setFieldValue(`stcrecords[${index}].score`, 1);
                                                                                if (values.stcrecords[index].patch === "") {
                                                                                    setFieldValue(`stcrecords[${index}].patch`, "App")
                                                                                }
                                                                            }}  type="radio" name={`stcrecords.${index}.score`} value={1} /><label for={`stcrecords.${index}.sits + "11"`}>
                                                                            </label>

                                                                            {/* <Field component="select" value={stcrecord.score} onChange={(e=>{
                                                                                    console.log(e.currentTarget.value)
                                                                                    setFieldValue(`stcrecords[${index}].score`,e.currentTarget.value)
                                                                            })} name={`stcrecords[${index}].score`}>
                                                                                    <option value="1">"1"</option>
                                                                                    <option value="2">"2"</option>
                                                                                    <option value="3">"3"</option>
                                                                                    <option value="4">"4"</option>
                                                                                    <option value="5">"5"</option>
                                                                            </Field> */}
                                                                    </div>
                                                                </div>
                                                                {
                                                                    values.stcrecords[index].score && values.stcrecords[index].score < 3 && (
                                                                    
                                                                            <div className="technical-form-box5">
                                                                                <div className="">
                                                                                    <span>Reason</span>
                                                                                </div>
                                                                                {/* <Field component="select" name={`stcrecords.${index}.patch`}>
                                                                                    <option value="App" label="App" />
                                                                                    <option value="Fpa" label="Fpa" />
                                                                                    <option value="Tkn" label="Tkn" />
                                                                                    <option value="Crm" label="Crm" />
                                                                                    <option value="Fpm" label="Fpm" />
                                                                                </Field> */}
                                                                                <select className="selectInput" name={`stcrecords.${index}.patch`}>
                                                                                    <option style={{color:"#262626 !important"}} value="App" >App</option>
                                                                                    <option style={{color:"#262626 !important"}} value="Fpa" >Fpa</option>
                                                                                    <option style={{color:"#262626 !important"}} value="Tkn" >Tkn</option>
                                                                                    <option style={{color:"#262626 !important"}} value="Crm" >Crn</option>
                                                                                    <option style={{color:"#262626 !important"}} value="Fpm" >Fpm</option>
                                                                                </select>
                                                                            </div>
                                                                     
                                                                    )
                                                                }
                                                            </div>
                                                        </div>

                                                    )) : (<div>Technical Competancy record not available</div>)

                                                }
                                            </div>)

                                    }} />

                            </div>
                        </div>
                        <div className={active === "non-tech-comp" ? "" : "hide-element"}>
                            <div className="table-body-container">
                                <div className="table-body-header">
                                    Section 3: Non-Technical Competency
                                        </div>
                                <br />
                                <div className=" nontechnical-form  margin-top-medium row marginradio">
                                    <div className=" col-lg-10 ">
                                        <h4>Knowledge</h4>
                                    </div>
                                    <div className="col-lg-10 ">
                                        <Field component="textarea" className="width100" rows="3" placeholder="Enter comments relating to APP & TKN here" value={values.knowledge} name="knowledge" />

                                    </div>
                                    <div className=" margin-top-medium col-lg-10 ">
                                        <h4>Skill</h4>
                                    </div>
                                    <div className="col-lg-10 ">
                                        <Field component="textarea" className="width100" rows="3" value={values.skil} name="skil" placeholder="Enter comments on COM, LTW, PDM,SWA, WLM here" />

                                    </div>
                                    <div className="col-lg-10 margin-top-medium">
                                        <h4>Attitude</h4>
                                    </div>
                                    <div className="col-lg-10">
                                        <Field component="textarea" className="width100" rows="4" placeholder="Enter your COM, LTW, PDM, SWA, WLM" value={values.attitude} name="attitude" />

                                    </div>
                                </div>

                                <div className=" nontechnical-form ">
                                    <div className="nontechnical-form-box" >
                                        <span><b>	Application of Procedures</b></span>
                                            <div className="rating-3">
                                                <input id="nontech-5" checked={values.app === 5} onChange={(e) => { setFieldValue("app", 5) }} className="marginradio" type="radio" name="app" value={5} /><label for="nontech-5"></label>
                                                <input id="nontech-4" checked={values.app === 4} onChange={(e) => { setFieldValue("app", 4) }} className="marginradio" type="radio" name="app" value={4} /><label for="nontech-4"></label>
                                                <input id="nontech-3" checked={values.app === 3} onChange={(e) => { setFieldValue("app", 3) }} className="marginradio" type="radio" name="app" value={3} /><label for="nontech-3"></label>
                                                <input id="nontech-2-" checked={values.app === 2} onChange={(e) => { setFieldValue("app", 2) }} className="marginradio" type="radio" name="app" value={2} /><label  for="nontech-2"></label>
                                                <input id="nontech-1" checked={values.app === 1} onChange={(e) => { setFieldValue("app", 1) }} className="marginradio" type="radio" name="app" value={1} /><label for="nontech-1"></label>
                                            </div>
                                    </div>    
                                    <div className="nontechnical-form-box" >
                                        <span><b>Technical Knowledge</b></span>
                                            <div className="rating-3">
                                                <input id="nontech-10" checked={values.tkn === 5} onChange={(e) => { setFieldValue("tkn", 5) }} className="marginradio" type="radio" name="tkn" value={5} /><label for="nontech-10"></label>
                                                <input id="nontech-9" checked={values.tkn === 4} onChange={(e) => { setFieldValue("tkn", 4) }} className="marginradio" type="radio" name="tkn" value={4} /><label for="nontech-9"></label>
                                                <input  id="nontech-8" checked={values.tkn === 3} onChange={(e) => { setFieldValue("tkn", 3) }} className="marginradio" type="radio" name="tkn" value={3} /><label for="nontech-8"></label>
                                                <input id="nontech-7" checked={values.tkn === 2} onChange={(e) => { setFieldValue("tkn", 2) }} className="marginradio" type="radio" name="tkn" value={2} /><label for="nontech-7"></label>
                                                <input id="nontech-6" checked={values.tkn === 1} onChange={(e) => { setFieldValue("tkn", 1) }} className="marginradio" type="radio" name="tkn" value={1} /><label for="nontech-6"></label>
                                            </div>
                                    </div>
                                    <div className="nontechnical-form-box">
                                        <span><b>Flight Path with Automation</b></span>
                                        <div className="rating-3">
                                                <input id="nontech-15" checked={values.fpa === 5} onChange={(e) => { setFieldValue("fpa", 5) }} className="marginradio" type="radio" name="fpa" value={5} /><label for="nontech-15"></label>
                                                <input id="nontech-14" checked={values.fpa === 4} onChange={(e) => { setFieldValue("fpa", 4) }} className="marginradio" type="radio" name="fpa" value={4} /><label for="nontech-14"></label>
                                                <input id="nontech-13"  checked={values.fpa === 3} onChange={(e) => { setFieldValue("fpa", 3) }} className="marginradio" type="radio" name="fpa" value={3} /><label for="nontech-13"></label>
                                                <input id="nontech-12" checked={values.fpa === 2} onChange={(e) => { setFieldValue("fpa", 2) }} className="marginradio" type="radio" name="fpa" value={2} /><label for="nontech-12"></label>
                                                <input id="nontech-11" checked={values.fpa === 1} onChange={(e) => { setFieldValue("fpa", 1) }} className="marginradio" type="radio" name="fpa" value={1} /><label for="nontech-11"></label>
                                            </div>
                                        </div>
                                    <div className="nontechnical-form-box" >
                                        <span><b>Flight Path - manual</b></span>
                                        <div className="rating-3">
                                                <input id="nontech-20" checked={values.fpm === 5} onChange={(e) => { setFieldValue("fpm", 5) }} className="marginradio" type="radio" name="fpm" value={5} /><label for="nontech-20"></label>
                                                <input id="nontech-19" checked={values.fpm === 4} onChange={(e) => { setFieldValue("fpm", 4) }} className="marginradio" type="radio" name="fpm" value={4} /><label for="nontech-19"></label>
                                                <input id="nontech-18" checked={values.fpm === 3} onChange={(e) => { setFieldValue("fpm", 3) }} className="marginradio" type="radio" name="fpm" value={3} /><label for="nontech-18"></label>
                                                <input id="nontech-17" checked={values.fpm === 2} onChange={(e) => { setFieldValue("fpm", 2) }} className="marginradio" type="radio" name="fpm" value={2} /><label for="nontech-17"></label>
                                                <input id="nontech-16" checked={values.fpm === 1} onChange={(e) => { setFieldValue("fpm", 1) }} className="marginradio" type="radio" name="fpm" value={1} /><label for="nontech-16"></label>
                                        </div>
                                    </div>
                                    <div className="nontechnical-form-box" >
                                        <span><b>Communication</b></span>
                                        <div className="rating-3">
                                                <input id="nontech-25" checked={values.com === 5} onChange={(e) => { setFieldValue("com", 5) }} className="marginradio" type="radio" name="com" value={5} /><label for="nontech-25"></label>
                                                <input id="nontech-24" checked={values.com === 4} onChange={(e) => { setFieldValue("com", 4) }} className="marginradio" type="radio" name="com" value={4} /><label for="nontech-24"></label>
                                                <input id="nontech-23" checked={values.com === 3} onChange={(e) => { setFieldValue("com", 3) }} className="marginradio" type="radio" name="com" value={3} /><label for="nontech-23"></label>
                                                <input id="nontech-22" checked={values.com === 2} onChange={(e) => { setFieldValue("com", 2) }} className="marginradio" type="radio" name="com" value={2} /><label for="nontech-22"></label>
                                                <input id="nontech-21" checked={values.com === 1} onChange={(e) => { setFieldValue("com", 1) }} className="marginradio" type="radio" name="com" value={1} /><label for="nontech-21"></label>
                                            </div>
                                        </div>
                                    <div className="nontechnical-form-box" >
                                        <span><b>Leadership & Teamwork</b></span>
                                            <div className="rating-3">
                                                <input id="nontech-30" checked={values.ltw === 5} onChange={(e) => { setFieldValue("ltw", 5) }} className="marginradio" type="radio" name="ltw" value={5} /><label for="nontech-30"></label>
                                                <input id="nontech-29" checked={values.ltw === 4} onChange={(e) => { setFieldValue("ltw", 4) }} className="marginradio" type="radio" name="ltw" value={4} /><label for="nontech-29"></label>
                                                <input id="nontech-28" checked={values.ltw === 3} onChange={(e) => { setFieldValue("ltw", 3) }} className="marginradio" type="radio" name="ltw" value={3} /><label for="nontech-28"></label>
                                                <input id="nontech-27" checked={values.ltw === 2} onChange={(e) => { setFieldValue("ltw", 2) }} className="marginradio" type="radio" name="ltw" value={2} /><label for="nontech-27"></label>
                                                <input id="nontech-26" checked={values.ltw === 1} onChange={(e) => { setFieldValue("ltw", 1) }} className="marginradio" type="radio" name="ltw" value={1} /><label for="nontech-26"></label>
                                            </div>
                                    </div>
                                    <div className="nontechnical-form-box" >
                                        <span><b>Pilots decision making</b></span>
                                        <div className="rating-3">
                                                <input id="nontech-35" checked={values.pdm === 5} onChange={(e) => { setFieldValue("pdm", 5) }} className="marginradio" type="radio" name="pdm" value={5} /><label for="nontech-35"></label>
                                                <input id="nontech-34" checked={values.pdm === 4} onChange={(e) => { setFieldValue("pdm", 4) }} className="marginradio" type="radio" name="pdm" value={4} /><label for="nontech-34"></label>
                                                <input id="nontech-33" checked={values.pdm === 3} onChange={(e) => { setFieldValue("pdm", 3) }} className="marginradio" type="radio" name="pdm" value={3} /><label for="nontech-33"></label>
                                                <input id="nontech-32" checked={values.pdm === 2} onChange={(e) => { setFieldValue("pdm", 2) }} className="marginradio" type="radio" name="pdm" value={2} /><label for="nontech-32"></label>
                                                <input id="nontech-31" checked={values.pdm === 1} onChange={(e) => { setFieldValue("pdm", 1) }} className="marginradio" type="radio" name="pdm" value={1} /><label for="nontech-31"></label>
                                        </div>
                                    </div>    
                                    <div className="nontechnical-form-box" >
                                        <span><b>Situational Awareness</b></span>
                                        <div className="rating-3">
                                                <input id="nontech-40" checked={values.saw === 5} onChange={(e) => { setFieldValue("saw", 5) }} className="marginradio" type="radio" name="saw" value={5} /><label for="nontech-40"></label>
                                                <input id="nontech-39" checked={values.saw === 4} onChange={(e) => { setFieldValue("saw", 4) }} className="marginradio" type="radio" name="saw" value={4} /><label for="nontech-39"></label>
                                                <input id="nontech-38" checked={values.saw === 3} onChange={(e) => { setFieldValue("saw", 3) }} className="marginradio" type="radio" name="saw" value={3} /><label for="nontech-38"></label>
                                                <input id="nontech-37" checked={values.saw === 2} onChange={(e) => { setFieldValue("saw", 2) }} className="marginradio" type="radio" name="saw" value={2} /><label for="nontech-37"></label>
                                                <input id="nontech-36" checked={values.saw === 1} onChange={(e) => { setFieldValue("saw", 1) }} className="marginradio" type="radio" name="saw" value={1} /><label for="nontech-36"></label>
                                        </div>
                                    </div>    
                                    <div className="nontechnical-form-box" >
                                        <span><b>Workload Management</b></span>
                                        <div className="rating-3">
                                            <input id="nontech-45" className="marginradio" type="radio" name="wlm" value={5} onChange={(e) => {
                                                setFieldValue("wlm", 5)
                                            }} checked={values.wlm === 5} /><label for="nontech-45"></label>
                                            <input id="nontech-44" className="marginradio" onChange={(e) => {
                                                setFieldValue("wlm", 4)
                                            }} type="radio" name="wlm" value={4} checked={values.wlm === 4} /><label for="nontech-44"></label>
                                             <input id="nontech-43" className="marginradio" type="radio" name="wlm" value={3} onChange={(e) => {
                                                setFieldValue("wlm", 3)
                                            }} checked={values.wlm === 3} /><label for="nontech-43"></label>
                                            <input id="nontech-42" className="marginradio" type="radio" name="wlm" onChange={(e) => {
                                                setFieldValue("wlm", 2)
                                            }} value={2} checked={values.wlm === 2} /><label for="nontech-42"></label>
                                            <input id="nontech-41" className="marginradio" type="radio" name="wlm" value={1} onChange={(e) => {
                                                setFieldValue("wlm", 1)
                                            }} checked={values.wlm === 1} /><label for="nontech-41"></label>
                                            </div>
                                        </div>
                                        <div className="">
                                            {/* <Text title="Total SCORE" value={totalscore} disabled /> */}
                                            <h2 className="total-score">Total Score: {totalscore}</h2>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div className={active === "remark" ? "" : "hide-element"}>
                            <div className="table-body-container">
                                <div className="table-body-header">Section 4: Remark</div>
                                <div className="client-list-divider"></div>
                                <div className="non-tech-comp-text">
                                    <h5>Overall Remarks</h5>
                                    <Field component="textarea" className="width100" rows="5" placeholder="Enter your Remarks Here..!" value={values.remarkstext} name="remarkstext" />
                                </div>
                                <div className="table-body-header">Section 5: Result</div>
                                <div className="result-container">
                                    <div className="box" style={{
                                        cursor: 'pointer',
                                        background: satifactory === "Satisfactory" || simformdetails.resulttext === "Satisfactory" ? "aliceblue" : ""
                                    }} onClick={() => {
                                        setFieldValue('resulttext', 'Satisfactory')
                                        setSatifactory('Satisfactory')

                                    }}>
                                        <div>
                                            <i className="fa fa-check-circle result-icon-style" />
                                            <div className="box-btn-1">Satisfactory</div>
                                        </div>
                                    </div>
                                    <div className="box" style={{
                                        cursor: 'pointer',
                                        background: satifactory === "Un-Satisfactory" || simformdetails.resulttext === "Un-Satisfactory" ? "black" : ""
                                    }} onClick={(event) => {
                                        event.preventDefault()
                                        setFieldValue('resulttext', 'Un-Satisfactory')
                                        setSatifactory('Un-Satisfactory')
                                    }} >
                                        <div>
                                            <i className="fa fa-times-circle result-icon-style" />
                                            <div className="box-btn-2" >Un-Satisfactory</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className={active === "signature" ? "" : "hide-element"}>
                            <br />
                            <div className="table-body-container">
                            <div className="table-body-header">Section 6: Signature</div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="non-tech-comp-text">
                                        <h3>Trainer Signature</h3>
                                        <div style={{  width: '620px', height: '320px',border: '1px solid black' }}>
                                            <img className="signclass" src={simformdetails.trainersign && simformdetails.trainersign !== '' ? simformdetails.trainersign : blankImage} alt="trainer signature" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="non-tech-comp-text">
                                        <h3>Trainee Signature</h3>
                                        <div style={{  width: '620px', height: '320px',border: '1px solid black' }}>
                                            <SignaturePad  penColor='black' canvasProps={{ width: '600px', height: '300px', }} ref={signaturPadRef} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="signature-container-sign">
                                <h5>Note:  Save trainees signature for form submission.</h5>
                                <h5>Trainee to sign the form,After obtaining the signature,Click on save signature to PREVIEW / SUBMIT the form.</h5>
                            </div>
                            <div className="signature-container-buttonbox">
                                <button style={{padding:"0px 10px",marginLeft:"36px"}} className="cancel-button" onClick={(e) => {
                                    e.preventDefault();
                                    signaturPadRef.current.clear()
                                    setFieldValue('traineesign', '');
                                }}>Clear Signature</button>
                                <button className="crew-button" onClick={(e) => {
                                    e.preventDefault();
                                    signatureSave = signaturPadRef.current.toDataURL()
                                    if (!signaturPadRef.current.isEmpty()) {
                                        setFieldValue('traineesign', signatureSave);
                                    } else {
                                        alert.show('Signature is Required')
                                    }
                                }}>Save Signature</button>
                           
                                   <div>
                                        <button style={{display:"block",margin:"10px auto", backgroundColor:"#DC3645",width:"200px"}}  className=" crew-button" id="signature-delete-button" onClick={e => {
                                            e.preventDefault();
                                            deleteform();
                                        }} type="submit">DELETE FORM</button>
                                  
                                    {
                                        showSubmit && (
                                            <React.Fragment>
                                                <div className="col-lg-3">
                                                    <button className="save-button" onClick={async (e) => {
                                                        e.preventDefault();
                                                        await submitformIndex();
                                                    }} type="submit"><label>SUBMIT</label></button>
                                                </div>
                                                {/* <div className="col-lg-4">
                                                    <button className="previewbut" onClick={async (e) => {
                                                        e.preventDefault();
                                                        await submitform(false);
                                                    }} type="submit"><label>PREVIEW FORM</label></button>
                                                </div> */}
                                            </React.Fragment>
                                        )
                                    }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>)
            }}
        </Formik >
    )
}

export default SimFormSections
